module.exports = "/_next/static/images/slide13-ae7be94221ade582aa66a06d27372ecd.webp";